import { jsx as _jsx } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgIconCheck = (props, ref) =>
  _jsx('svg', {
    viewBox: '0 0 24 24',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: _jsx('path', {
      fillRule: 'evenodd',
      d: 'M18.573 6.18a1 1 0 0 1 .246 1.393l-6.316 9.024a2 2 0 0 1-3.053.267l-4.157-4.157a1 1 0 1 1 1.414-1.414l4.157 4.157 6.317-9.023a1 1 0 0 1 1.392-.246Z',
      clipRule: 'evenodd',
    }),
  })
const ForwardRef = forwardRef(SvgIconCheck)
export default ForwardRef
